import * as React from 'react'
import { CastingStore, StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import { onlyUniqueByTransform } from '../../../../services/utils/lodash.service'
import HorizontalTitledSeparatorComponent from '../../../shared/horizontal-titled-separator.component'
import LoadingComponent from '../../../shared/loading.component'
import SelectableListComponent from '../../../shared/selectable-list.component'
import { InfoBox, InfoBoxError, PrimaryButton } from '../casting-styled.component'

const i18nScoped = new I18nService(require('./casting-city-results-picker.component.yml'))

export default function CastingCityResultsPickerComponent ({ data: { cityResults, city, market, customer }, store }: StoreProps) {
  const selectCity = React.useCallback(async (city: CastingStore['data']['city']) => {
    await store.setCity(city)
    store.nextFocus({ closeOnMobile: true })
  }, [store])

  const addresses: CastingStore['data']['city'][] = customer?.addresses?.sort((a, b) => b.id - a.id)
    .map(address => ({
      id: address.id.toString(),
      city: address.city,
      postalCode: address.zipcode,
      lat: address.latitude,
      lng: address.longitude,
      content: `${address.city} (${address.zipcode})`
    }))
    .filter(onlyUniqueByTransform(_ => _.content))
    
  switch(cityResults?.status) {
    case 'loading':
      return <LoadingComponent align="center" presentation="inline" />
    case 'no-results':
      return <InfoBoxError>{ i18nScoped.t(`city_not_found.${market.field_for_geocoding}`) }</InfoBoxError>
    case 'error':
      return <InfoBoxError>{ i18nScoped.t('geocoding_error') }</InfoBoxError>
    case 'invalid':
      return <InfoBoxError>{ i18nScoped.t(`invalid_city.${market.field_for_geocoding}`) }</InfoBoxError>
    case 'results':
      return <>
        <SelectableListComponent name="castingCity" data={ cityResults.data } value={ city } onChange={ selectCity } formatter={ item => item.content } />

        { cityResults.data.length === 1 && <PrimaryButton
          id="js-test-tooltip-next"
          style={{ display: 'block', marginTop: '1em' }}
          onClick={ () => selectCity(cityResults.data[0]) }
          children={ i18nScoped.t('next') } /> }
      </>
    default:
      return <>
        <InfoBox>{ i18nScoped.t(`no_city.${market.field_for_geocoding}`) }</InfoBox>

        { addresses?.length > 0 && <>
          <HorizontalTitledSeparatorComponent className="u-mtm u-mbm" children={ i18nScoped.t('or_select_existing') } />
          <SelectableListComponent name="castingAddress" data={ addresses } value={ city } onChange={ selectCity } formatter={ item => item.content } />
        </> }
      </>
  }
}
